import Bootstrap from './Bootstrap';
import pubsub from '../src/shared/helpers/events'; // eslint-disable-line
import getGlobalFromWindow from '../src/shared/helpers/getGlobalFromWindow';
import packageJson from '../package.json';


class ComponentLoader {
  constructor(componentList) {
    const rebateConfigHash = getGlobalFromWindow('rebateConfigHash');
    this.componentList = componentList;

    /* eslint-disable-next-line no-console */
    console.log(`Marketplace Components version: ${packageJson.version}`);
    if (rebateConfigHash) {
      console.log(`Rebate Config Hash: ${rebateConfigHash}`)
    }
  }

  load() {
    const loader = document.getElementById('se_loader');

    if (loader) {
      loader.style.display = 'none';
    }

    this.componentList.forEach((Component) => {
      new Bootstrap(Component).init();
    });
  }
}

export default ComponentLoader;
